import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import NewOrgMemberComponent from '../containers/Registration/NewOrgMember';
const NewOrgMember = NewOrgMemberComponent as React.ComponentType<any>;
import Registration from '../containers/Registration';
import Login from '../containers/Login';
import ResetPassword from '../containers/Password/ResetPassword';
import ForgotPassword from '../containers/Password/ForgotPassword';

const PublicRoutes = () => (
  <Routes>
    <Route path="/register/new-org-member/:id" element={<NewOrgMember />} />
    <Route path="/register" element={<Registration />} />
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/auth/password/email" element={<ResetPassword />} />
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);
export default PublicRoutes;
